export enum ErrorCodeInspections {
  PendingPunches = 'System.ArgumentException',
}

export const ERROR_CODE_BAD_REQUEST = 400;
export const ERROR_CODE_CONFLICT = 409;
export const ERROR_CODE_SERVER_ERROR = 500;
